const ChainIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="#707070"
    >
      <path d="M17.5 7.5a7.5 7.5 0 0 1 0 15H12.5a7.5 7.5 0 0 1 0-15h5zm0 2.5H12.5a5 5 0 0 0 0 10H17.5a5 5 0 0 0 0-10zm-5 2.5h5a2.5 2.5 0 0 1 0 5h-5a2.5 2.5 0 0 1 0-5z" />
    </svg>
  )
}

export default ChainIcon
